export const DEFAULT_ECC_LIMITS: Record<string, number> = {
  L: 100,
  M: 100,
  Q: 100,
  H: 100,
};
